// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XsJ5x","select":"styles_select__KPIVR"};